/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cmspage_Kind_Page1Inputs */

const vi_cmspage_kind_page1 = /** @type {(inputs: Cmspage_Kind_Page1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trang`)
};

/**

* @param {Cmspage_Kind_Page1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const cmspage_kind_page1 = /** @type {((inputs?: Cmspage_Kind_Page1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmspage_Kind_Page1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cmspage_kind_page1(inputs)
});
export { cmspage_kind_page1 as "cmsPage_kind_page" }